import {
    GREEN,
    GREY,
    ORANGE,
    PURPLE,
    RED,
    AQUA,
    purpleGradient,
    blueGradient,
    turquoiseGradient,
    purpleGradientColors,
    redGradientColors,
    aquaGradientColors,
    blueGradientColors,
    turquoiseGradientColors,
    goldGradientColors, redGradient, aquaGradient
} from '../config/colors/colors';

// ----------------------------------------------------------------------

// SETUP PALETTE

const PRIMARY = {
    lightest: PURPLE[50],
    lighter: PURPLE[200],
    light: PURPLE[300],
    main: PURPLE[600],
    dark: PURPLE[700],
    darker: GREY[500],
    shadow: PURPLE[100],
    contrastGreyText: GREY[25],
    contrastText: '#fafafa',
};

const SECONDARY = {
    lighter: GREY[200],
    light: GREY[300],
    main: GREY[700],
    dark: GREY[800],
    darker: GREY[900],
    contrastText: '#fff'
};

const INFO = {
    lighter: '#D0F2FF',
    light: '#74CAFF',
    main: '#1890FF',
    dark: '#0C53B7',
    darker: '#04297A',
    contrastText: '#fff'
};

const SUCCESS = {
    lighter: GREEN[25],
    light: GREEN[50],
    mainLight: GREEN[200],
    main: GREEN[500],
    dark: GREEN[700],
    darker: GREEN[800],
    contrastText: GREY[800]
};

const WARNING = {
    lighter: ORANGE[25],
    light: ORANGE[50],
    main: ORANGE[500],
    dark: ORANGE[700],
    darker: ORANGE[800],
    contrastText: GREY[800]
};

const ERROR = {
    lighter: RED[25],
    light: RED[50],
    mainLight: RED[200],
    main: RED[500],
    dark: RED[700],
    darker: RED[800],
    contrastText: '#fff'
};

const LIGHT = {
    lightest: '#ffffff',
    lighter: '#F6FAFD',
    light: '#EBF7FF',
    main: '#E0ECFF',
    dark: '#C7DBFF',
    darker: '#A5C8FF',
    contrastText: GREY[800]
};

const palette = {
    common: { black: '#000', white: '#fff' },
    themeGradient: {
        primary: purpleGradient
    },
    gradients: {
        primary: purpleGradient,
        secondary: turquoiseGradient,
        info: blueGradient,
        error: redGradient,
        success: aquaGradient
    },
    gradientColors: {
        primary: purpleGradientColors,
        secondary: goldGradientColors,
        success: aquaGradientColors,
        error: redGradientColors,
        info: blueGradientColors,
        warning: turquoiseGradientColors
    },
    icon: {
        main: GREY[500],

    },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    light: LIGHT,
    aqua: AQUA,
    purple: PURPLE,
    divider: GREY[200],
    borderGrey: GREY[200],
    borderColor: PRIMARY.light,
    text: {
        primary: GREY[800],
        secondary: GREY[500],
        disabled: GREY[500],
        default: GREY[700],
        light: GREY[300],
    },
    background: {
        paper: GREY[50],
        default: '#fff',
        neutral: GREY[100],
        neutralGrey: GREY[200],
        greyDark: GREY[500],

    },
    action: {
        active: GREY[400],
        hover: GREY[100],
        selected: GREY[200],
        disabled: GREY[200],
        disabledBackground: GREY[100],
        focus: GREY[200],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48
    },
    focusColor: PRIMARY.focusColor,
    mainSelected: PRIMARY.focusColor,
};

export default palette;
